import styled from 'styled-components';


const UploadWrapper = styled.div`
    /* display: inline-block; */
`;

export { UploadWrapper }